export function scheduleHubspotTicketRowScroll(
  ticketId: string,
  delayMs: number,
) {
  window.setTimeout(() => {
    const row = document.querySelector<HTMLElement>(
      `[data-ticket-id="${ticketId}"]`,
    );

    row?.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
  }, delayMs);
}
